/** This allows an attribute like `data-checked` to read <div data-checked /> instead of <div data-checked="true" /> */
export const dataAttr = (condition: boolean | undefined): string | undefined =>
  condition ? '' : undefined
